import * as yup from "yup";
import { VALIDATOR_STRING_REQUIRED } from "../../../../../../constants/validation/validators";

export const formValidationSchema = yup.object().shape({
  roleTitle: VALIDATOR_STRING_REQUIRED,
  level: VALIDATOR_STRING_REQUIRED.matches(/^-?[0-9]+$/, "Только цифры"),
});
